import { render } from "./RenderedElementImage.vue?vue&type=template&id=3dc771ca&scoped=true"
import script from "./RenderedElementImage.vue?vue&type=script&lang=js"
export * from "./RenderedElementImage.vue?vue&type=script&lang=js"

import "./RenderedElementImage.vue?vue&type=style&index=0&id=3dc771ca&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Callum\\Desktop\\k1890584_watkins_callum_code\\mo-books\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc771ca"]])

export default __exports__